<app-modal [show]="show" (onHide)="close()" [title]="translationManager.getTranslation('Нови рок на пројекту')">
  <div class="page-content container">
    <!-- <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Нови рок на пројекту') }}
    </h1>
  </div> -->

    <div class="page-data shadow-sm">
      <!-- <div class="page-part">
        <div class="alert alert-info">
          <span *ngIf="state === viewState.Create">
            <i class="fa fa-info-circle"></i>
            {{ translationManager.getTranslation('Страница за додавање новог рока на пројекту') }}
          </span>
          <span *ngIf="state === viewState.Edit">
            <i class="fa fa-info-circle"></i>
            {{ translationManager.getTranslation('Страница за измену рока на пројекту') }}
          </span>
        </div>
      </div> -->

      <div class="form-blocks">
        <div class="content">
          <div class="page-part">
            <div class="form-element">
              <label>{{ translationManager.getTranslation('Назив') }}</label>
              <div class="content" [ngClass]="{ 'with-action': true }">
                <div class="static">
                  <span>{{ form.elements['name'].value | appvalue }}</span>
                </div>
                <div class="action" *ngIf="taskId>0 || ( state === viewState.Create)"  >
                  <a href="javascript:;" [title]=" translationManager.getTranslation('Селектуј таск')"
                    (click)="selectTask()">
                    <i class="fa fa-search mr-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element">
              <label>{{ translationManager.getTranslation('Опис') }}</label>
              <div class="content">
                <div class="static">
                  <span>{{ form.elements['description'].value | appvalue }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element" [ngClass]="{ 'error': isDeadlineForCompletionRequired }">
              <label>{{ translationManager.getTranslation('Рок за извршење') }}</label>
              <div class="content">
                <input type="date" [(ngModel)]="form.elements['deadlineForCompletion'].value" />
              </div>
              <div class="errors">
                <span *ngIf="isDeadlineForCompletionRequired">
                  <i
                    class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element">
              <div class="form-element">
                <label>{{ translationManager.getTranslation('Одговорна организациона јединица') }}</label>
                <div class="content" [ngClass]="{ 'with-action': true }">
                  <div class="static">
                    <span>{{ form.elements['organizationalUnitName'].value | appvalue }}</span>
                  </div>
                  <div class="action">
                    <a href="javascript:;"
                      [title]=" translationManager.getTranslation('Селектуј одговорну организациону јединицу')"
                      (click)="selectOrganizationalUnit()">
                      <i class="fa fa-search mr-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page-part">
            <div class="form-element">
              <div class="form-element">
                <label>{{ translationManager.getTranslation('Приказ добављачу') }}</label>

                <div class="content">
                  <div class="action">
                    <span><input type="checkbox" name="displaysToSuppliersCheck" [checked]="selectDisplaysToSuppliersId"
                        (click)="selectDisplaysToSuppliers($event)" style="width: 50px;"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="app-modal-actions">
            <button class="btn btn-success" (click)="submit()">
              <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation("Сачувај") }}
            </button>
            <button (click)="close()" class="btn btn-warning">
              <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation("Одустани") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<task-select #taskSelectComponent></task-select>
<organizational-unit-select #organizationalUnitSelectComponent></organizational-unit-select>
